var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive-box--box-content-banker-archive-file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.006 11.873C2.901 13.577 4.268 15 5.976 15h36.05c1.708 0 3.075 -1.423 2.97 -3.127 -0.062 -0.982 -0.126 -1.853 -0.189 -2.617 -0.21 -2.555 -2.173 -4.506 -4.728 -4.711C36.801 4.28 31.542 4 24.001 4c-7.542 0 -12.8 0.28 -16.079 0.545C5.367 4.75 3.405 6.7 3.194 9.256c-0.063 0.764 -0.127 1.634 -0.188 2.617Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 15v11c0 5.868 0.205 10.096 0.414 12.885 0.192 2.557 2.144 4.509 4.701 4.7 2.789 0.21 7.017 0.415 12.885 0.415 5.868 0 10.096 -0.205 12.885 -0.414 2.557 -0.192 4.509 -2.144 4.7 -4.701 0.21 -2.789 0.415 -7.017 0.415 -12.885V15",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1096",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.013 24.585c0.065 1.434 1.3 2.316 2.735 2.35C19.142 26.97 21.197 27 24 27s4.858 -0.031 6.252 -0.064c1.435 -0.035 2.67 -0.916 2.735 -2.35a12.932 12.932 0 0 0 0 -1.171c-0.065 -1.434 -1.3 -2.316 -2.735 -2.35A265.288 265.288 0 0 0 24 21c-2.803 0 -4.858 0.031 -6.252 0.064 -1.435 0.035 -2.67 0.916 -2.735 2.35a12.935 12.935 0 0 0 0 1.171Z",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBox);
export default __webpack_public_path__ + "static/media/archive-box.1cd2fdcad7be567a6b16e8932ca71ea0.svg";
export { ForwardRef as ReactComponent };